<template>
  <div>
    <form class="col-md-13 col-lg-6">
      <div>
        <div>
          <div class="">
            <label for="full_name" class="form-label">Name*:</label>
            <input type="text" class="form-control" id="full_name" v-model="form.full_name" />
          </div>

          <div class="row mt-3">
            <div class="col-md-6">
              <label for="phone" class="form-label">Phone*:</label>
              <input type="number" class="form-control" id="phone" v-model="form.phone" />
            </div>

            <div class="col-md-6">
              <label for="ext" class="form-label">Ext:</label>
              <input type="text" class="form-control" id="ext" v-model="form.ext" />
            </div>
          </div>

          <div class="mt-3">
            <label for="email" class="form-label">Email*:</label>
            <input type="email" class="form-control" id="email" v-model="form.email" />
          </div>

          <div class="mt-3">
            <label for="username" class="form-label">Username* (i.e. - "JDoe"):</label>
            <input type="text" class="form-control" id="username" v-model="form.username" />
          </div>

          <div class="mt-3">
            <label for="password" class="form-label">Password*:</label>
            <input type="text" class="form-control" id="password" v-model="form.password" />
          </div>

          <div class="mt-3">
            <label for="auth_num" class="form-label">Seurtiy Role*:</label>
            <select class="form-select form-control" v-model.number="form.auth_num">
              <option value="">--Select--</option>
              <option v-for="role in this.allSecurityRoles.result" :key="role.id" :value="role.sec_id">
                {{ role.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </form>
    <div class=" mt-2">
      <div class="">
        <input class="btn btn-primary btn-sm-block mr-2" type="submit" name="add" value="Save" @click="onSubmit" />
        <router-link
          :to="{
            name: 'ManageUsers',
          }"
          @click.native="scrollToTop"
          class="btn btn-danger text-white btn-sm-block mr-2"
          type="button"
          >Cancel</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddUsersForm',
  data() {
    return {
      form: {
        full_name: '',
        phone: '',
        ext: '',
        email: '',
        username: '',
        password: '',
        auth_num: '',
      },
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      if (this.form.full_name == '') {
        alert('Please enter a name');
        return;
      }

      if (this.form.phone == '') {
        alert('Please enter a phone number');
        return;
      }

      if (this.form.email == '') {
        alert('Please enter an email address');
        return;
      }

      if (this.form.username == '') {
        alert('Please enter a username');
        return;
      }

      if (this.form.password == '') {
        alert('Please enter a password');
        return;
      }

      if (this.form.auth_num == '') {
        alert('Please select a role');
        return;
      }

      // compare password checks
      if (this.form.password == 'password' || this.form.password.length < 5 || this.form.password === this.form.username) {
        this.$store.commit('manageSystemUsers/SET_PASSWORD_CHECK', true);
        this.$router.push({
          name: 'ManageUsers',
        });
        return;
      }

      // api call
      this.$store.dispatch('manageSystemUsers/addSystemUser', this.form).then((resp) => {
        console.log(resp.status);
        if (resp.status === 200) {
          this.$router
            .push({
              name: 'ManageUsers',
              params: {
                success: true,
                action: 'The user has been created.',
              },
            })
            .then(() => {
              window.scrollTo(0, 0);
            });
        } else {
          alert(resp.data.message);
        }
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  computed: {
    allSecurityRoles() {
      return this.$store.getters['manageSystemUsers/allSecurityRoles'];
    },
  },
  mounted() {
    this.$store.dispatch('manageSystemUsers/fetchAllSecurityRoles', {
      pg_num: 1,
      pg_size: 100,
      searchterm: '',
    });
  },
};
</script>
<style scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;

  border-radius: 5px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

.form-label,
.form-check-label {
  margin-top: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.form-check {
  padding-left: 2rem !important;
}
</style>
